"use client";

import { useState, useEffect } from 'react';
import { isLoggedIn } from '../utils/utils';
import User from './User/User';
import Login from './Login/Login';

const Home = () => {
    const [loggedIn, setLoggedIn] = useState(false);

    useEffect(() => {
        setLoggedIn(isLoggedIn());
    }, []);

    return loggedIn ? <User /> : <Login />;
};

export default Home;
